// =============================================
// COMPONENTE: WebhookTriggerNode - Nó Trigger de Webhook
// =============================================
// Arquivo: WebhookTriggerNode.tsx
// Descrição: Nó para receber webhooks externos como entrada do fluxo
// =============================================

import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Zap, Link, Lock } from 'lucide-react';
import ActionsBadge from './ActionsBadge';
import '../NodeStyles.css';

const WebhookTriggerNode: React.FC<NodeProps> = ({ data, selected }) => {
  const {
    label,
    webhookPath,
    method = 'POST',
    authentication = 'none',
    description,
    actions
  } = data;

  const getAuthIcon = () => {
    if (authentication === 'bearer' || authentication === 'api_key') {
      return <Lock size={12} />;
    }
    return null;
  };

  return (
    <div className={`flow-node webhook-trigger-node ${selected ? 'selected' : ''}`}>
      <div className="node-header webhook-trigger-header">
        <Zap className="node-icon" size={18} />
        <span className="node-title">{label || 'Webhook Trigger'}</span>
      </div>

      <div className="node-body">
        {webhookPath && (
          <div className="node-detail">
            <Link size={14} />
            <span className="node-detail-text">
              <strong>{method}</strong> {webhookPath}
            </span>
          </div>
        )}
        {authentication !== 'none' && (
          <div className="node-badge">
            {getAuthIcon()} {authentication.toUpperCase()}
          </div>
        )}
        {description && (
          <div className="node-description">{description}</div>
        )}
        <ActionsBadge actions={actions} />
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        className="flow-handle"
      />
    </div>
  );
};

export default WebhookTriggerNode;
